import { GameRegion } from '../generated/api'

export const FRESHDESK_WIDGET_ENGLISH_ID = 80000007951
export const FRESHDESK_WIDGET_WELSH_ID = 80000008802

// export const SUPPORTED_LANGUAGES = [
//   { name: LanguageNames.English, localeCode: LanguageCodes['en-GB'] },
//   { name: LanguageNames.Cymraeg, localeCode: LanguageCodes['cy-GB'] },
// ]

export const YEAR_GROUPS: Record<GameRegion, string[]> = {
  [GameRegion.England]: [
    'Reception',
    'Year 1',
    'Year 2',
    'Year 3',
    'Year 4',
    'Year 5',
    'Year 6',
    'Year 7',
    'Year 8',
    'Year 9',
    'Year 10',
    'Year 11',
    'Year 12',
    'Year 13',
  ],
  [GameRegion.Scotland]: [
    'Primary 1',
    'Primary 2',
    'Primary 3',
    'Primary 4',
    'Primary 5',
    'Primary 6',
    'Primary 7',
    'Secondary 1',
    'Secondary 2',
    'Secondary 3',
    'Secondary 4',
    'Secondary 5',
    'Secondary 6',
  ],
  [GameRegion.Ireland]: [
    'Primary 1',
    'Primary 2',
    'Primary 3',
    'Primary 4',
    'Primary 5',
    'Primary 6',
    'Primary 7',
    'Year 8',
    'Year 9',
    'Year 10',
    'Year 11',
    'Year 12',
    'Year 13',
    'Year 14',
  ],
} as const
